<template>
    <div class="userList">
        <div class="useritem_div">
            <div class="useritem">
                <div class="usertitle">
                    <FSpanTil title="小组" viewBox="0 0 1338 1024" IconSize="30">我创建的小组</FSpanTil>
                </div>
                <div class="usertable">
                    <el-table
                            :data="create.tableData"
                            border
                            style="width: 100%">
                        <el-table-column
                                prop="groupName"
                                label="小组名称"
                                align="center"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="createDateTime"
                                label="创建时间"
                                align="center"
                        >
                        </el-table-column>
                        <el-table-column
                                label="组员详情"
                                class-name="table_xq"
                                align="center">
                            <template slot-scope="scope">
                                <div class="xqSpan" @click="getGroupDialog(0,scope.row,'创建')">
                                    <span>组员详情</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="权限设置"
                                align="center"
                                class-name="table_qx"
                                width="150">
                            <template slot-scope="scope">
                                <FSvg title="权限" IconSize="30" @click.native="getAuthDialog(0,scope.row,'整组')"></FSvg>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="解散本组"
                                align="center"
                                class-name="table_qx"
                                width="150">
                            <template slot-scope="scope">
                                <FSvg title="解散组" IconSize="27" @click.native="getGroupDisband(scope.row)"></FSvg>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="userpage">
                    <FPage :pageSize="create.pageSize" :total="create.total" @page="getPage(arguments,0)"></FPage>
                </div>
            </div>
            <div class="useritem">
                <div class="usertitle">
                    <FSpanTil title="小组" viewBox="0 0 1338 1024" IconSize="30">我所属的小组</FSpanTil>
                </div>
                <div class="usertable">
                    <el-table
                            :data="belong.tableData"
                            border
                            style="width: 100%;">
                        <el-table-column
                                prop="groupName"
                                label="小组名称"
                                align="center"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="createDateTime"
                                label="创建时间"
                                align="center"
                        >
                        </el-table-column>
                        <el-table-column
                                label="组员详情"
                                align="center"
                                class-name="table_xq">
                            <template slot-scope="scope">
                                <div class="xqSpan" @click="getGroupDialog(0,scope.row,'所属')">
                                    <span>组员详情</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="退出本组"
                                align="center"
                                class-name="table_qx"
                                width="150">
                            <template slot-scope="scope">
                                <FSvg title="退群" IconSize="25" @click.native="getGroupClose(scope.row)"></FSvg>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="userpage pageblock">
                    <FPage :pageSize="belong.pageSize" :total="belong.total" @page="getPage(arguments,1)"></FPage>
                </div>
            </div>
        </div>
        <FDialog :dialog="groupDialog.show" moveWidth="80%" :title="groupDialog.title"
                 class="userList_group_dialog" @close="getGroupDialog(1)">
            <div class="gloupList">
                <el-table
                        border
                        :data="groupDialog.tableData"
                        style="width: 100%"
                        @row-click="getGroupRowClick"
                        highlight-current-row
                >
                    <el-table-column
                            align="center"
                            v-if="groupDialog.type==='创建'"
                            width="55">
                        <template slot-scope="scope">
                            <div class="table_radio">
                                <el-radio v-model="groupDialog.id" :label="scope.row.id">{{scope.row.id}}</el-radio>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            width="200"
                            prop="userName"
                            label="姓名">
                    </el-table-column>
                    <el-table-column
                            align="center"
                            prop="phone"
                            label="电话"
                            width="200">
                    </el-table-column>
                    <el-table-column
                            align="center"
                            prop="company"
                            label="所属公司">
                    </el-table-column>
                </el-table>
            </div>
            <div class="btnlist" v-if="groupDialog.type==='创建'">
                <FBtn title="删除" :type="2" :disabled="!groupDialog.id" @click="getGroupRemove"></FBtn>
                <FBtn title="权限设置" :type="2" :disabled="!groupDialog.id"
                      @click="getAuthDialog(0,'','个人')"></FBtn>
            </div>
        </FDialog>
        <FDialog :dialog="authDialog.show" moveWidth="30%" :title="authDialog.type+ ' - ' + authDialog.title"
                 class="userList_auth_dialog" @close="getAuthDialog(1)">
            <ul class="glouplist">
                <el-checkbox-group v-model="authDialog.checkList">
                    <li v-for="(item,index) in authDialog.checkboxPerm" :key="index">
                        <el-checkbox :label="item.checked">{{item.label}}</el-checkbox>
                    </li>
                </el-checkbox-group>
            </ul>
            <div class="btnlist">
                <FBtn title="确定" :IconSize="20" :type="2" @click="getAuthSave()"></FBtn>
            </div>
        </FDialog>
    </div>
</template>

<script>
    import {
        creatGroupList,
        getGroupMembersInfo,
        GetUserGroupListByUserId,
        RemoveGroup,
        SetGroupMembersAccess,
        SetGroupAccess,
        RemoveGroupMembers,
        GetGroupMembersAccess,
        GetGroupAccess
    } from '@/assets/axios/optionManage/userlist'
    import {getUser} from '@/assets/js/basis'

    /**
     @author xiaoye
     @date 2020/4/17 11:44 上午
     */
    export default {
        name: 'userList',
        components: {},
        props: {},
        data() {
            return {
                //创建:
                create: {
                    tableData: [],
                    pageSize: 5,
                    pageIndex: 1,
                    total: 10,
                },
                //所属
                belong: {
                    tableData: [],
                    pageSize: 5,
                    pageIndex: 1,
                    total: 10,
                },
                //组员
                groupDialog: {
                    show: false,
                    tableData: [],
                    type: '',
                    groupId: '',
                    id: ''
                },
                //权限
                authDialog: {
                    show: false,
                    checkList: [],
                    type: '',
                    title: '',
                    checkboxPerm: [
                        {checked: '1', label: '数据分析资源'},
                        {checked: '2', label: '已创建大屏'},
                        {checked: '3', label: '数据接入资源'},
                        {checked: '4', label: '故事板'}
                    ],
                },
            }
        },
        methods: {
            //获取参数
            init() {
                this.creatList();
                this.beLongList();
            },
            //创建的组列表
            creatList() {
                creatGroupList({
                    pageIndex: this.create.pageIndex,
                    pageSize: this.create.pageSize,
                }).then(res => {
                    if (res.code === 200) {
                        this.create.tableData = res.data.dataTabel;
                        this.create.total = res.data.totalCount;
                    } else {
                        this.create.tableData = [];
                    }
                })
            },
            //所属的小组
            beLongList(pageIndex) {
                GetUserGroupListByUserId({
                    pageIndex: this.belong.pageIndex,
                    pageSize: this.belong.pageSize
                }).then(res => {
                    if (res.code === 200) {
                        this.belong.tableData = res.data.dataTabel;
                        this.belong.total = res.data.totalCount;
                    } else {
                        this.belong.tableData = [];
                    }
                })
            },
            //分页
            getPage(ev, type) {
                if (type === 0) {
                    this.create.pageIndex = ev[0];
                    this.create.pageSize = ev[1];
                    this.creatList();
                } else if (type === 1) {
                    this.belong.pageIndex = ev[0];
                    this.belong.pageSize = ev[1];
                    this.beLongList()
                }
            },
            //组员详情弹框
            getGroupDialog(type, row, index) {
                if (type === 0) {
                    this.groupDialog.type = index;
                    this.groupDialog.title = row.groupName;
                    this.groupDialog.groupId = row.id;
                    this.getGroupData(row);
                } else if (type === 1) {
                    this.groupDialog = {
                        show: false,
                        tableData: [],
                        type: '',
                        groupId: '',
                        id: ''
                    };
                }
            },
            //组员详情数据
            getGroupData(row, load) {
                if (!load) {
                    this.groupDialog.tableData = [];
                }
                this.groupDialog.id = '';
                getGroupMembersInfo({
                    groupId: row.id
                }).then(res => {
                    if (res.code === 200) {
                        this.groupDialog.tableData = res.data.dataTabel;
                        this.groupDialog.show = true;
                    }
                })
            },
            //组员详情点击某一行数据
            getGroupRowClick(row) {
                if (this.groupDialog.type === '创建') {
                    this.groupDialog.id = row.id;
                }
            },
            //删除 组成员
            getGroupRemove() {
                let row = {};
                let name = '';
                this.create.tableData.map((item) => {
                    if (this.groupDialog.groupId === item.id) {
                        row = item;
                    }
                });
                this.groupDialog.tableData.map((item) => {
                    if (this.groupDialog.id === item.id) {
                        row = item;
                    }
                });
                this.$alert('您确定要删除成员【' + name + '】吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    showCancelButton: true,
                    closeOnPressEscape: false,
                    closeOnClickModal: false,
                    customClass: 'alert_allCom',
                }).then(() => {
                    RemoveGroupMembers({
                        groupId: this.groupDialog.groupId,
                        userIds: this.groupDialog.id
                    }).then(res => {
                        if (res.code === 200) {
                            this.getGroupData(row, 1);
                            this.getMsg(res.message, 'success')
                        }
                    })
                });
            },
            //权限弹框
            getAuthDialog(type, row, index) {
                if (type === 0) {
                    this.authDialog.type = index;
                    if (index === '整组') {
                        this.groupDialog.groupId = row.id;
                        this.authDialog.title = row.groupName;
                        this.getAuthAllData();
                    } else if (index === '个人') {
                        let name = '';
                        this.groupDialog.tableData.map((item) => {
                            if (item.id === this.groupDialog.id) {
                                name = item.userName;
                            }
                        });
                        this.authDialog.title = name;
                        this.getAuthOneData();
                    }
                } else {
                    this.authDialog = {
                        show: false,
                        checkList: [],
                        type: '',
                        title: '',
                        checkboxPerm: [
                            {checked: '1', label: '数据分析资源'},
                            {checked: '2', label: '已创建大屏'},
                            {checked: '3', label: '数据接入资源'},
                            {checked: '4', label: '故事板'}
                        ],
                    };
                }
            },
            //获取 整组权限
            getAuthAllData() {
                this.authDialog.checkList = [];
                GetGroupAccess({
                    groupId: this.groupDialog.groupId
                }).then(res => {
                    if (res.code === 200) {
                        if (res.data.dataTabel) {
                            this.authDialog.checkList = res.data.dataTabel.split(",");
                        } else {
                            this.authDialog.checkList = [];
                        }
                        this.authDialog.show = true;
                    }
                })
            },
            //获取 个人权限
            getAuthOneData() {
                this.authDialog.checkList = [];
                GetGroupMembersAccess({
                    groupId: this.groupDialog.groupId,
                    userId: this.groupDialog.id,
                }).then(res => {
                    if (res.code === 200) {
                        if (res.data.dataTabel) {
                            if (res.data.dataTabel[0].access) {
                                this.authDialog.checkList = res.data.dataTabel[0].access.split(",");
                            }
                        } else {
                            this.authDialog.checkList = [];
                        }
                        this.authDialog.show = true;
                    }
                })
            },
            //保存
            getAuthSave() {
                if (this.authDialog.type === '整组') {
                    this.getAuthAllSave();
                } else if (this.authDialog.type === '个人') {
                    this.getAuthOneSave();
                }
            },
            //保存 整组权限
            getAuthAllSave() {
                let check = [];
                for (let item of this.authDialog.checkList) {
                    if (item) {
                        check.push(item)
                    }
                }
                SetGroupAccess({
                    groupId: this.groupDialog.groupId,
                    access: check.join(',')
                }).then(res => {
                    if (res.code === 200) {
                        this.getAuthDialog(1);
                        this.getMsg(res.message, 'success');
                    }
                })
            },
            //保存 个人权限
            getAuthOneSave() {
                let check = [];
                for (let item of this.authDialog.checkList) {
                    if (item) {
                        check.push(item)
                    }
                }
                SetGroupMembersAccess({
                    groupId: this.groupDialog.groupId,
                    userId: this.groupDialog.id,
                    access: check.join(',')
                }).then(res => {
                    if (res.code === 200) {
                        this.getAuthDialog(1);
                        this.getMsg(res.message, 'success');
                    }
                })
            },
            //解散本组
            getGroupDisband(row) {
                this.$alert('您确定要解散【' + row.groupName + '】这个小组吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    showCancelButton: true,
                    closeOnPressEscape: false,
                    closeOnClickModal: false,
                    customClass: 'alert_allCom',
                }).then(() => {
                    RemoveGroup({
                        groupId: row.id
                    }).then(res => {
                        if (res.code === 200) {
                            this.creatList();
                            this.getMsg(res.message, 'success');
                        }
                    })
                })
            },
            //退出本组
            getGroupClose(row) {
                this.$alert('您确定要退出【' + row.groupName + '】这个小组吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    showCancelButton: true,
                    closeOnPressEscape: false,
                    closeOnClickModal: false,
                    customClass: 'alert_allCom',
                }).then(() => {
                    RemoveGroupMembers({
                        groupId: row.id,
                        userIds: getUser().id
                    }).then(res => {
                        if (res.code === 200) {
                            this.beLongList();
                            this.getMsg(res.message, 'success')
                        }
                    })
                });
            }
        },
        mounted() {

            this.init();
        },
        destroyed() {

        }
    }
</script>

<style lang="less">
    .userList {
        width: 100%;
        height: 100%;
        overflow: auto;

        .useritem_div {
            width: 100%;
            height: 100%;
            padding: 26px;

            .useritem {
                min-height: 400px;

                .usertable {
                    margin-top: 12px;

                    .el-table {

                        //权限
                        .table_qx {
                            padding: 5px 0;
                        }

                        //详情
                        .table_xq {
                            .xqSpan {
                                display: inline-block;
                                width: 100%;
                                cursor: pointer;
                                line-height: 20px;
                                text-align: center;

                                > span {
                                    color: @green;
                                    display: inline-block;
                                }
                            }

                            .xqSpan:hover {
                                > span {
                                    border-bottom: 1px solid;
                                }
                            }
                        }
                    }
                }

                .userpage {
                    margin-top: 14px;
                    text-align: right;
                }
            }
        }


        //详情弹框
        .userList_group_dialog {

            .gloupList {
                max-height: 500px;
                overflow: auto;
            }

            .table_radio {
                .bigRadio;

                .el-radio__label {
                    display: none;
                }
            }

            .btnlist {
                display: inline-block;
                width: 100%;
                text-align: right;
                margin-top: 15px;
            }
        }

        //权限
        .userList_auth_dialog {
            .glouplist {
                li {
                    margin-top: 20px;
                    display: inline-block;
                    width: calc((100% - 40px) / 2);
                }

                .bigCheck;
            }

            .btnlist {
                display: inline-block;
                width: 100%;
                text-align: right;
                margin-top: 20px;
            }
        }
    }
</style>